import { useEffect, useState } from 'react';
import BizosTypography from 'components/bizos/bizos-typography';
import { Checkbox } from 'components/commons';
import Loading from 'components/loading';
import { useGetLoanQuery, useSetAcceptedBizOsAccountMutation } from 'generated/graphql';
import { useNavigation } from 'hooks/index';
import { registerTagmanagerEvent } from 'configs/trackers';
import { getLoanApplicationParams } from 'utils/utils';
import BizcontaLogo from 'assets/svg/biz-conta-title.svg';
import BizcontaFlag from 'assets/svg/bizconta_flag.svg'
import Arrows from 'assets/svg/bizos-arrows';
import Dolar from 'assets/svg/bizos-dolar';
import BarCode from 'assets/svg/bar-code';

import './assets/css/choose-bank-account.styles.scss';



type ChooseBankAccountProps = {
    nextScreen(): void;
};

enum TagEvent {
    BIZ_CONTA = 'escolha-conta-bancaria-bizconta',
    OUTRA_CONTA = 'escolha-conta-bancaria-outraconta',
};

const ChooseBankAccount = ({ nextScreen }: ChooseBankAccountProps) => {
    const [acceptedBizOsAccount, setAcceptedBizOsAccount] = useState<boolean | null>(null);
    const [acceptedBizOsAccountMutation] = useSetAcceptedBizOsAccountMutation();
    const { goToDocumentCheckout } = useNavigation();
    const loanApplicationId = getLoanApplicationParams();

    const { data: { loanApplication }, loading } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    const handleSetBizAccount = () => {
        setAcceptedBizOsAccount(true);
    };

    const handleSetOthers = () => {
        setAcceptedBizOsAccount(false);
    };

    const handleSetAcceptedBizOsAccount = async () => {
        try {
            await acceptedBizOsAccountMutation({
                variables: {
                    acceptedBizOsAccount: acceptedBizOsAccount || false,
                    id: loanApplicationId,
                }
            });
            registerTagmanagerEvent(acceptedBizOsAccount ? TagEvent.BIZ_CONTA : TagEvent.OUTRA_CONTA);
            nextScreen();
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (loanApplication && loanApplication.acceptedBizOsAccount !== null) {
            goToDocumentCheckout();
        }
    }, [loanApplication]);

    useEffect(() => {
        window.addEventListener('beforeunload', handleSetAcceptedBizOsAccount);

        return () => window.removeEventListener('beforeunload', handleSetAcceptedBizOsAccount);

    }, [handleSetAcceptedBizOsAccount, acceptedBizOsAccount]);

    return (
        (!loanApplication || loading) ? <Loading />
        : (
            <div className="choose-bank-account">
                <header className="choose-bank-account__header">
                    <div className="choose-bank-account__header__container">
                        <BizosTypography variant="heading-1" weight="bold">
                            escolha a conta bancária
                        </BizosTypography>
                    </div>
                </header>
                <main className="choose-bank-account__main">
                    <div className="choose-bank-account__main__container">
                        <div className="choose-bank-account__card">
                            <div className="choose-bank-account__logo-container">
                                <Checkbox
                                    value={!!acceptedBizOsAccount}
                                    onChange={handleSetBizAccount}
                                    className="choose-bank-account__checkbox"
                                    renderLabel={() => (
                                        <div className="choose-bank-account__logo">
                                            <img src={BizcontaLogo} />
                                        </div>
                                    )}
                                />
                                <div className="choose-bank-account__flag">
                                    <img src={BizcontaFlag} alt="" />
                                </div>
                            </div>
                            <BizosTypography variant="paragraph" weight="normal">
                                Termine o cadastro em minutos e receba seu crédito <br className="hidden-sm" />
                                na BizConta, a conta digital PJ gratuira da Biz :
                            </BizosTypography>
                            <ul className="choose-bank-account__list">
                                <li className="choose-bank-account__list__item">
                                    <div className="choose-bank-account__list__icon">
                                        <Arrows />
                                    </div>
                                    <BizosTypography variant="text" weight="bold" color="gray">
                                        TED e Pix gratuitos
                                    </BizosTypography>
                                </li>
                                <li className="choose-bank-account__list__item">
                                    <div className="choose-bank-account__list__icon">
                                        <Dolar />
                                    </div>
                                    <BizosTypography variant="text" weight="bold" color="gray">
                                        Sem tarifas ou mensalidades
                                    </BizosTypography>
                                </li>
                                <li className="choose-bank-account__list__item">
                                    <div className="choose-bank-account__list__icon">
                                        <BarCode />
                                    </div>
                                    <BizosTypography variant="text" weight="bold" color="gray">
                                        Adie seus boletos com o MaisBiz
                                    </BizosTypography>
                                </li>
                            </ul>
                        </div>
                        <div className="choose-bank-account__card">
                            <Checkbox
                                value={!acceptedBizOsAccount && acceptedBizOsAccount !== null}
                                className="choose-bank-account__checkbox"
                                renderLabel={() => <BizosTypography variant="text">seguir com a conta que já possuo</BizosTypography>}
                                label="seguir com a conta que já possuo"
                                onChange={handleSetOthers}
                            />
                        </div>
                    </div>
                </main>
                <footer className="choose-bank-account__footer">
                    <div className="choose-bank-account__container choose-bank-account__footer__container">
                        <button className="choose-bank-account__button" disabled={(acceptedBizOsAccount === null)} onClick={handleSetAcceptedBizOsAccount}>
                            continuar
                        </button>
                    </div>
                </footer>
            </div>
        )
    );
}

export default ChooseBankAccount;
